__turbopack_context__.v({
  "button": "showCase-module-scss-module__r1Hn1W__button",
  "case": "showCase-module-scss-module__r1Hn1W__case",
  "content": "showCase-module-scss-module__r1Hn1W__content",
  "description": "showCase-module-scss-module__r1Hn1W__description",
  "image": "showCase-module-scss-module__r1Hn1W__image",
  "showCase": "showCase-module-scss-module__r1Hn1W__showCase",
  "title": "showCase-module-scss-module__r1Hn1W__title",
});
